import FullWidthLayout from '@/layouts/FullWidthLayout.vue';
import { AccessTypeType } from '@shared/generated';
import { useUserStore } from '@shared/stores/user';
import type {
  RouteLocationNormalizedGeneric,
  RouteLocationNormalizedLoadedGeneric
} from 'vue-router';

const routes = [
  {
    path: '/equipment',
    name: 'Equipment',
    meta: {
      requiresAuth: true,
      title: 'Equipment',
      layout: FullWidthLayout
    },
    component: () => import('@/views/Equipment.vue')
  },
  {
    path: '/my-preferences',
    name: 'UserPreferences',
    meta: {
      requiresAuth: true,
      title: 'User preferences',
      layout: FullWidthLayout
    },
    component: () => import('@/views/UserPreferences.vue')
  },
  {
    path: '/company-profile',
    name: 'CompanyProfile',
    meta: {
      requiresAuth: true,
      title: 'Company profile',
      layout: FullWidthLayout
    },
    component: () => import('@/views/CompanyProfile.vue'),
    beforeEnter: (
      _: RouteLocationNormalizedGeneric,
      from: RouteLocationNormalizedLoadedGeneric
    ) => {
      const userStore = useUserStore();
      const currentS3User = userStore.currentS3User;
      if (currentS3User?.access.type !== AccessTypeType.ADMIN) {
        return from;
      }
      return true;
    }
  }
];

export default routes;
